var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrowBorderSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 19.6155C15.3106 19.6155 19.6155 15.3106 19.6155 10.0002C19.6155 4.68972 15.3106 0.384766 10.0002 0.384766C4.68972 0.384766 0.384766 4.68972 0.384766 10.0002C0.384766 15.3106 4.68972 19.6155 10.0002 19.6155Z",
    stroke: "#404040",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5334 9.84661L11.6788 7.00507C11.575 6.90877 11.4378 6.85658 11.2962 6.85949C11.1546 6.8624 11.0197 6.92019 10.9199 7.02068C10.8201 7.12117 10.7633 7.2565 10.7613 7.3981C10.7594 7.53971 10.8126 7.67653 10.9096 7.77969L12.8265 9.68738H6.05728C5.91233 9.68738 5.77331 9.74497 5.67082 9.84747C5.56832 9.94996 5.51074 10.089 5.51074 10.2339C5.51074 10.3789 5.56832 10.5179 5.67082 10.6204C5.77331 10.7229 5.91233 10.7805 6.05728 10.7805H12.8265L10.9096 12.6881C10.8126 12.7913 10.7594 12.9281 10.7613 13.0697C10.7633 13.2113 10.8201 13.3467 10.9199 13.4472C11.0197 13.5476 11.1546 13.6054 11.2962 13.6084C11.4378 13.6113 11.575 13.5591 11.6788 13.4628L14.5334 10.6212C14.5844 10.5704 14.6248 10.5101 14.6524 10.4436C14.68 10.3771 14.6942 10.3059 14.6942 10.2339C14.6942 10.162 14.68 10.0907 14.6524 10.0242C14.6248 9.95778 14.5844 9.89742 14.5334 9.84661Z",
    fill: "#404040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowBorderSmall);
export default __webpack_public_path__ + "static/media/right-arrow-border-small.3dab1d2f60aca6f70cb27a8843c4c853.svg";
export { ForwardRef as ReactComponent };